/* import __COLOCATED_TEMPLATE__ from './trending-topics-title.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import templateOnlyComponent from '@ember/component/template-only';

export interface Args {}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

const TrendingTopicsTitle = templateOnlyComponent<Signature>();
export default TrendingTopicsTitle;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::FinAiAgent::Analyze::TopicTrends::TrendingTopicsTitle': typeof TrendingTopicsTitle;
  }
}
